<template>
  <div>
    <v-row class="pa-3 ma-0">
      <v-col cols="12">
        <BaseTitle
          pageTitle="COMUNICADO"
          :hasBackButton="false"
          :hasClose="hasClose"
          @close="close($event)"
        >
        </BaseTitle>
      </v-col>

      <v-col cols="12">
        {{ communication.ds_comunicado }}
      </v-col>
      <v-col cols="5">
        Data de Expiração: {{ dateFormat(communication.dt_expiracao) }}
      </v-col>
    </v-row>
  </div>
</template>
<script>
import BaseTitle from "../../../components/UI/BaseTitle.vue";
import moment from "moment";
import { mapActions } from "vuex";
export default {
  components: {
    BaseTitle
  },

  data() {
    return {
      loading: false
    };
  },

  props: {
    hasClose: {
      type: Boolean,
      default: false
    },
    communication: {
      type: Object
    }
  },

  async created() {
    if (!this.communication.view) {
      await this.viewCommunicationUser({
        cd_comunicado: this.communication.cd_comunicado
      });
    }
  },

  methods: {
    ...mapActions({
      viewCommunicationUser: "$_communication/viewCommunication"
    }),

    dateFormat(date) {
      if (date) return moment(date).format("DD/MM/YYYY");
      return "";
    },

    close() {
      this.$emit("close", false);
    }
  }
};
</script>
